import React from 'react'
import {Container, Row, Col, Button, Carousel} from "react-bootstrap"
import {Link, useHistory} from "react-router-dom"
import LightSpeed from 'react-reveal/LightSpeed';

import Bmw from "../../style/Img/Bmw/Bmw s1000rr.jpg"
import Bmw1 from "../../style/Img/Bmw/Bmw1.jpg"
import Bmw2 from "../../style/Img/Bmw/Bmw2.jpg"
import Kawasaki from "../../style/Img/Kawasaki/Kawasaki z750.jpg"
import Kawasaki1 from "../../style/Img/Kawasaki/Kawasaki1.jpg"
import Kawasaki2 from "../../style/Img/Kawasaki/Kawasaki2.jpeg"
import Vespa from "../../style/Img/Vespa/Vespa.jpg"
import Vespa1 from "../../style/Img/Vespa/Vespa1.jpg"
import Vespa2 from "../../style/Img/Vespa/Vespa2.jpg"



function ListaMoto() {
    let history = useHistory();

    return (
        <Container fluid>
            {/* SEZIONE BANNER */}
            <Container fluid id="banner_recovered" className="head-banner text-center text-white">
            <Container>
            <Row>
                <Col>
                    <h1><strong>8-Bit Motors</strong></h1>
                </Col>
            </Row>
        </Container>
        </Container>

        {/* SEZIONE INTRODUZIONE */}
        <Container className=" text-center mt-3">
            
            <h2><strong>Catalogo Motocicli</strong></h2>
            <h3>I nostri motocicli disponibili al noleggio 24/7</h3>
            
        </Container>

        {/* SEZIONE AUTOMOBILI */}
        <Container className="mt-4">
            <Row>
                <Col>
                <LightSpeed left>
                <Link to={"/veicoli/specifiche/Bmw S1000RR"}>
                <Carousel>
                    <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={Bmw}
                        alt="First slide"
                        />
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={Bmw1}
                        alt="Second slide"
                        />
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={Bmw2}
                        alt="Third slide"
                        />
                    </Carousel.Item>
                </Carousel>
                </Link>
                    </LightSpeed>
                </Col>
                <div class="col-lg-6 text-center">
                    <LightSpeed right>
                        <h2>Bmw S1000RR</h2>
                        <h3>Tariffa:</h3>
                        <p>
                        4€ all'ora


                        </p>
                        <Button variant="dark" onClick={() => {history.push("/veicoli/specifiche/Bmw S1000RR")}}>Specifiche</Button>
                    </LightSpeed>
                </div>
            </Row>

            <Row className="mt-4">
                <Col>
                <LightSpeed left>
                <Link to={"/veicoli/specifiche/Kawasaki Z750"}>
                <Carousel>
                    <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={Kawasaki}
                        alt="First slide"
                        />
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={Kawasaki1}
                        alt="Second slide"
                        />
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={Kawasaki2}
                        alt="Third slide"
                        />
                    </Carousel.Item>
                </Carousel>
                </Link>
                    </LightSpeed>
                </Col>
                <div class="col-lg-6 text-center">
                    <LightSpeed right>
                        <h2>Kawasaki 750</h2>
                        <h3>Tariffa:</h3>
                        <p>
                        3€ all'ora


                        </p>
                        <Button variant="dark" onClick={() => {history.push("/veicoli/specifiche/Kawasaki Z750")}}>Specifiche</Button>
                    </LightSpeed>
                </div>
            </Row>

            <Row className="mt-4">
                <Col>
                <LightSpeed left>
                <Link to={"/veicoli/specifiche/Vespa"}>
                <Carousel>
                    <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={Vespa}
                        alt="First slide"
                        />
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={Vespa1}
                        alt="Second slide"
                        />
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                        className="d-block w-100"
                        src={Vespa2}
                        alt="Third slide"
                        />
                    </Carousel.Item>
                </Carousel>
                </Link>
                    </LightSpeed>
                </Col>
                <div class="col-lg-6 text-center">
                    <LightSpeed right>
                        <h2>Vespa</h2>
                        <h3>Tariffa:</h3>
                        <p>
                        2€ all'ora


                        </p>
                        <Button variant="dark" onClick={() => {history.push("/veicoli/specifiche/Vespa")}}>Specifiche</Button>
                    </LightSpeed>
                </div>
            </Row>
        </Container>
        </Container>
    )
}

export default ListaMoto